import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { SM_QUEUE_SERVER } from "../constants/constants";
import { triggerNotifications } from "../Helpers/helperMessages";
import { isValidNumber, validateContactData } from "../utils/utils";
import { SingletonCallOutData } from '../Singletons/SingletonCallData';
let sharedCallOutData = new SingletonCallOutData();

export const setSvrUpdateData = (that, data, camId, callKey) => {
    const {EditableCallKey, EditableContactData} = that.sharedData.getCallIcon();
    if(!isValidNumber(camId))
    {
        triggerNotifications(that, MESSAGE_CODE.CALL_DATA[10302], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        return;
    }  
    const dataContact = validateContactData(data);
    const callKeyFinal = EditableCallKey && callKey ? callKey : sharedCallOutData.getCallOutDataFromCall().callKey
    const dataFinal = EditableContactData ? dataContact : validateContactData(sharedCallOutData.getCallOutDataFromCall().dataContact);
    if(!EditableCallKey && !EditableContactData)
    {
        triggerNotifications(that, MESSAGE_CODE.CALL_DATA[10303], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
        return;
    }
    
    !EditableCallKey && triggerNotifications(that, MESSAGE_CODE.CALL_DATA[10304], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    !EditableContactData && triggerNotifications(that, MESSAGE_CODE.CALL_DATA[10305], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);

    const message = {
        action: "UpdateDataCall",
        username: that.sharedData.getUserData().Login,
        userID: that.sharedData.getUserData().User_id,
        Data: dataFinal,
        callKey: callKeyFinal,
        CamId: parseInt(camId),
    };
    that.sendToRabbit(SM_QUEUE_SERVER, message);
    that.sharedData.setTemporalCallData(message, 'updateDataCall');
}
